import React from "react";
import { ActivityHistoryContainer } from "./ActivityHistory.styled";

const ActivityHistory = () => {
  return (
    <ActivityHistoryContainer>
      <h2>Activity History</h2>
      <p>User activity history will be displayed here.</p>
    </ActivityHistoryContainer>
  );
};

export default ActivityHistory;

